export default __webpack_public_path__ + "static/media/cosinte-logo.54caa07b.png";